import React from 'react';
import './Account_step_2.css';

import { Link } from 'react-router-dom';

class Account_step_2 extends React.Component {
    constructor(props) {
        super(props);

        this.handleChangeAndCheckUnique = this.handleChangeAndCheckUnique.bind(this);
    }


    handleChangeAndCheckUnique(event, type) {
        if (type === 'email') {
            this.props.handleChange(event);
        } else if (type === 'phone') {
            this.props.handlePhoneChange(event);
        };
        this.props.checkUnique(event, type);
    }

    /** Recognised email — offer a way out */
    renderLoginPrompt() {
        const returnTo = this.props.login_return_to;
        const loginPath = returnTo ? `/login?return_to=${encodeURIComponent(returnTo)}` : '/login';

        return (
            <p className='tiny_text signup_login_prompt'>
                <Link to={loginPath} className='green_text'>Log in instead.</Link>
            </p>
        );
    }

    render () {
        const showAt = this.props.showAtStep != null ? this.props.showAtStep : 2;
        if (this.props.currentStep !== showAt) {
            return null;
        };

        const errors = this.props.field_errors || {};

        return (
           <div>
                <h2 className='center'>How can we reach you?</h2>
                <p className='center small_text signup_field_helper'>
                    We verify your phone number because Greatest Gift moves real money.
                </p>
        
                <form>
                    
                    <p className='form_label'>Email </p>
                    <input 
                        type='email' 
                        id='user_email' 
                        name='user_email' 
                        placeholder='Example@email.com' 
                        onChange={this.props.handleChangeEmail} 
                        value={this.props.user_email}
                        autoFocus 
                        autoComplete='email'
                        onBlur={(event) => {this.props.checkUnique(event, 'email')}}/>
                    {errors.user_email ? <p className='tiny_text signup_field_error'>{errors.user_email}</p> : null}
                    {this.props.email_taken ? this.renderLoginPrompt() : null}

                    <p className='form_label'>US phone number</p>
                    <input 
                        type='text' 
                        id='user_phone_number' 
                        name='user_phone_number' 
                        placeholder='555-555-5555' 
                        maxLength='12'
                        onChange={(event) => {this.handleChangeAndCheckUnique(event, 'phone')}}  
                        value={this.props.user_phone_number}
                        autoComplete='tel-national'/>
                    {errors.user_phone_number ? <p className='tiny_text signup_field_error'>{errors.user_phone_number}</p> : null}
                    

                </form>

               

           </div>
        );
    }
}

export default Account_step_2;
